import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";

export const ModalEditarConcepto = (props) => {
    const txtNombre = useRef(null);
    const checkActivo = useRef(null);
    const [operacion, setOperacion] = useState(props.operacion || 2);
    const [errores, setErrores] = useState({});

    useEffect(() => {
        if (props.datos) {
            llenarCampos(props.datos);
        }

        if (operacion === 4) {
            deshabilitarCampos();
        } else if (operacion === 2) {
            habilitarCampos();
            setTimeout(() => txtNombre.current?.focus(), 100);
        }
    }, [props.datos, props.operacion]);

    const llenarCampos = (datos) => {
        if (txtNombre.current) {
            txtNombre.current.value = datos.nomconcep?.trim() || '';
        }
        if (checkActivo.current) {
            checkActivo.current.checked = datos.activo === true || datos.activo === 1;
        }
    };

    const deshabilitarCampos = () => {
        if (txtNombre.current) txtNombre.current.disabled = true;
        if (checkActivo.current) checkActivo.current.disabled = true;
    };

    const habilitarCampos = () => {
        if (txtNombre.current) txtNombre.current.disabled = false;
        if (checkActivo.current) checkActivo.current.disabled = false;
    };

    const validarCampos = () => {
        const nuevosErrores = {};
        let valido = true;

        if (!txtNombre.current?.value?.trim()) {
            nuevosErrores.nombre = "El nombre del concepto no debe estar en blanco";
            valido = false;
            txtNombre.current?.focus();
        }

        setErrores(nuevosErrores);
        return valido;
    };

    const aceptar = () => {
        if (operacion === 2) {
            if (!validarCampos()) return;
        }

        const datosActualizados = {
            codint: props.codIntegrante,
            nomint: props.nomIntegrante,
            codconcep: props.datos?.codconcep,
            nomconcep: txtNombre.current?.value?.toUpperCase()?.trim() || '',
            activo: checkActivo.current?.checked || false,
            activopagos: props.datos?.activopagos || false,
            operacion: operacion
        };

        if (props.onAceptar) {
            props.onAceptar(datosActualizados);
        }

        props.onHide();
    };

    const cancelar = () => {
        props.onHide();
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            if (operacion === 2) {
                aceptar();
            }
        }
    };

    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            size="md"
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header className="header-azulGradiant">
                <h3>
                    {operacion === 2 && (
                        <>
                            <i className="fa fa-edit me-2"></i>Editar Concepto de Nómina
                        </>
                    )}
                    {operacion === 4 && (
                        <>
                            <i className="fa fa-eye me-2"></i>Consultar Concepto de Nómina
                        </>
                    )}
                </h3>
                <button type="button" className="btn-close btn-close-white" onClick={cancelar}></button>
            </Modal.Header>
            <Modal.Body>
                {Object.keys(errores).length > 0 && (
                    <div className="alert alert-danger col-12" role="alert">
                        {Object.values(errores).map((error, index) => (
                            <div key={index}>• {error}</div>
                        ))}
                    </div>
                )}

                <fieldset className="col-12 m-0 p-3 border-table rounded">
                    <legend className="float-none m-0 w-auto px-2">
                        <i className="fa fa-tag me-1"></i> Datos del Concepto
                    </legend>

                    <div className="row col-md-12 mx-auto px-0">

                        <div className="input-group input-group-sm mb-2 col-md-12">
                            <span className="input-group-text">Cod. Concepto:</span>
                            <input
                                type="text"
                                className="form-control fw-bold"
                                value={props.datos?.codconcep || ''}
                                disabled={true}
                            />
                        </div>

                        <div className="input-group input-group-sm mb-2 col-md-12">
                            <span className="input-group-text">Nombre:</span>
                            <input
                                type="text"
                                className="form-control"
                                ref={txtNombre}
                                disabled={operacion === 4}
                                onKeyDown={handleKeyDown}
                                placeholder="Ingrese el nombre del concepto"
                            />
                        </div>

                        <div className="input-group input-group-sm mb-2 col-md-12">
                            <div className="form-check d-flex align-items-center">
                                <input
                                    className="form-check-input me-2"
                                    type="checkbox"
                                    id="checkActivo"
                                    ref={checkActivo}
                                    disabled={operacion === 4}
                                />
                                <label className="form-check-label" htmlFor="checkActivo">
                                    <i className="fa fa-check-circle text-success me-1"></i>
                                    Activo en Nómina General
                                </label>
                            </div>
                        </div>

                        <div className="input-group input-group-sm mb-2 col-md-12">
                            <span className="input-group-text">Integrante:</span>
                            <input
                                type="text"
                                className="form-control"
                                value={`${props.codIntegrante || ''} - ${props.nomIntegrante || ''}`}
                                disabled={true}
                            />
                        </div>
                    </div>
                </fieldset>
            </Modal.Body>
            <Modal.Footer className="footer-azulGradiant">
                {operacion === 2 && (
                    <button
                        type="button"
                        className="btn btn-sm rounded-pill px-4 btn-success"
                        onClick={aceptar}
                    >
                        <i className="fa fa-check me-2"></i>Aceptar
                    </button>
                )}
                <button
                    type="button"
                    onClick={cancelar}
                    className="btn btn-sm rounded-pill px-4 btn-danger"
                >
                    <i className="fa fa-times me-2"></i>Cancelar
                </button>
            </Modal.Footer>
        </Modal>
    );
};